////import Swal from "sweetalert2";
import moment from "moment";
import HelperMixin from '../../../Shared/HelperMixin.vue'

export default {
    name: "AddUser",
    mixins: [HelperMixin],
    async created() {
        await this.CheckLoginStatus();
        this.GetCities();
        this.GetCompanies();
        this.GetInfo();



        var today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();
        this.dateNow = mm + "/" + dd + "/" + yyyy;

    },
    components: {
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format("MMMM Do YYYY");
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY || h:mm a');
        },
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 100,
            pages: 0,
            state: 0,


            Info: [],
            Cities: [],
            Municipalities: [],
            KidnyCenter: [],
            TodayPatient: [],

            Companies: [],
            Devices: [],
            Felters: [],



            CityId: '',
            MunicipalitiesId: '',
            KidneyCenterId: '',

            CompanyId:'',
            DeviceId:'',
            FilterId:'',


            Patient: [],
            PatientId: '',
            ByDate: '',


            ManualAddDiloag: false,



            ruleForm: {
                PatientId: '',
                CompanyId: '',
                DeviceId: '',
                FilterId: '',
                UsedCount: '',
            },
            rules: {
                PatientId: this.$helper.Required(),
                CompanyId: this.$helper.Required(),
                DeviceId: this.$helper.Required(),
                FilterId: this.$helper.Required(),
                UsedCount: this.$helper.Required(),
            },














            
        };
    },
    methods: {

        GetCities() {
            this.$blockUI.Start();
            this.$http
                .GetCities()
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Cities = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetMunicipalities() {
            this.Municipalities = [];
            this.MunicipalitiesId = '';
            this.ruleForm.MunicipalitiesId = '';
            this.KidnyCenter = [];
            this.KidneyCenterId = '';
            this.ruleForm.KidneyCenterId = '';
            this.GetInfo();
            this.$blockUI.Start();
            this.$http.GetMunicipalitiesByCiteisID(this.CityId)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Municipalities = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetKednyCenter() {
            this.KidnyCenter = [];
            this.KidneyCenterId = '';
            this.ruleForm.KidneyCenterId = '';
            this.GetInfo();
            this.$blockUI.Start();
            this.$http
                .GetKednyCenterByCitie(this.MunicipalitiesId)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.KidnyCenter = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetCompanies() {
            this.$blockUI.Start();
            this.$http
                .GetAllCompanies()
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Companies = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetDviceById() {
            this.Devices = [];
            this.DeviceId = '';
            this.Felters = [];
            this.FilterId = '';
            this.$blockUI.Start();
            this.$http
                .GetDviceById(this.CompanyId)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Devices = response.data.info;
                    this.GetInfo();
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetFilterById() {
            this.Felters = [];
            this.FilterId = '';
            this.$blockUI.Start();
            this.$http
                .GetFilterById(this.DeviceId)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Felters = response.data.info;
                    this.GetInfo();
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetDviceById_Add() {
            this.Devices = [];
            this.ruleForm.DeviceId = '';
            this.Felters = [];
            this.ruleForm.FilterId = '';
            this.$blockUI.Start();
            this.$http
                .GetDviceById(this.ruleForm.CompanyId)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Devices = response.data.info;
                    this.GetInfo();
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetFilterById_Add() {
            this.Felters = [];
            this.ruleForm.FilterId = '';
            this.$blockUI.Start();
            this.$http
                .GetFilterById(this.ruleForm.DeviceId)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Felters = response.data.info;
                    this.GetInfo();
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },



        GetInfo() {

            var From = '';
            var To = '';
            if (this.ByDate) {
                From = this.ChangeDate(this.ByDate[0]);
                To = this.ChangeDate(this.ByDate[1]);
            }
                
            this.$blockUI.Start();
            this.$http
                .GetUsedDailyReportInfo(this.pageNo, this.pageSize, this.CityId, this.MunicipalitiesId, this.KidneyCenterId,
                    From, To, this.CompanyId, this.DeviceId, this.FilterId)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },


        Print() {

            try {

                var item = this.Info;

                let tableRows = '';
                let index = 0;
                let sum = 0;
                item.filter(el => el.Status != 9).forEach(el => {
                    sum += el.usedCount;
                    tableRows += `
                    <tr>
                        <td>${++index}</td>
                        <td>${el.companyName}</td>
                        <td>${el.deviceName}</td>
                        <td>${el.filterName}</td>
                        <td>${el.usedCount}</td>
                    </tr>
                    `
                })

                let reportHTML =

                    `
<!DOCTYPE html>
<html lang="ar" dir="rtl">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="ie=edge" />

    <title>Page</title>

    <link
      href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap"
      rel="stylesheet"
    />

    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
      crossorigin="anonymous"
    />
  </head>

  <body>
    <!-- <div class="controls-container"> -->
    <!-- <button id="btnPrint">Print</button> -->
    <!-- <button id="btnAddPage">Add New Page</button> <br /> -->
    <!-- </div> -->
    <div class="main-container">
      <div class="page-container">
        <div class="page-inner">
          <div class="d-flex justify-content-between">
            <p class="fs-6">
              <img
                src="data:image/jpeg;base64,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"
                width="60"
                style="margin-top: -9px"
              />

              وزارة الصحة
            </p>
            <center class="fs-6 fw-bolder">
               لـــــيــبــيــــا
            </br>
            بيانات الإستهلاك
              
            </center>
            <p class="fs-6">${this.dateNow} </p>
          </div>

		  
		  
          <table style="direction: rtl;"
            class="table table-sm table-bordered text-center border border-dark align-middle mt-2"
          >
            <thead>
              <tr class="bg-gray">
			  <th >#</th>
			  <th > إسم الشركة</th>
			  <th >اسم الجهاز</th>
			  <th >الفلتر</th>
			  <th >الكمية المستهلكة</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
               <tr height="20">

                        <td
                            colspan="4"
                            style="font-weight: bold; text-align: left; font-size: 13px;text-align: right;"
                        >
                        </td>
                        <td
                        style="font-weight: bold; text-align: center; font-size: 10px"
                          >
                        <span style="text-decoration: underline"> ${sum} </span>
                    </td>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </body>

  <style>
    body {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      background-color: #fafafa;
      color: #414142;
      font: 10px 'Cairo', sans-serif;
      -webkit-print-color-adjust: exact !important;
    }
    * {
      box-sizing: border-box;
      -moz-box-sizing: border-box;
    }

    .page-container {
      width: 360mm;
      height: 210mm;
      padding: 0mm;
      margin: 10mm auto;
      border: 1px #d3d3d3 solid;
      border-radius: 5px;
      background: white;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
    .page-inner {
      padding: 0;
      height: 297mm;
      padding: 10mm;
    }

    /* .page-inner table,
.page-inner td,
.page-inner th {
  padding: 2mm;
  border-collapse: collapse;
  border: 1px solid #414142;
} */

    @page {
      size: A4 landscape;
      margin: 0;
    }

    @media print {
      html,
      body {
        height: 210mm;
        width: 297mm;
      }
      .page-container {
        margin: 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
      }
    }

    .controls-container {
      color: #414142;
      background: #f1f1f2;
      padding: 5px;
      border: 1px solid #d1d3d4;
      border-radius: 2px;
      position: fixed;
      top: 50px;
      left: 10px;
      font-size: 12px;
    }

    .controls-container button {
      background-color: #333333;
      border: none;
      color: white;
      padding: 15px 32px;
      text-align: center;
      text-decoration: none;
      display: block;
      width: 100%;
      margin-bottom: 5px;
      outline: none;
      cursor: pointer;
      transition: 0.3s;
    }

    .controls-container button:hover {
      background-color: #4caf50;
    }

    @media print {
      .controls-container {
        display: none !important;
      }
    }

    th,
    td {
      line-height: 10px;
    }

    .bg-gray {
      background-color: #c0c0c0 !important;
    }

    .bg-gray-striped-1 {
      background-color: #e1e1e1 !important;
    }

    .bg-gray-striped-2 {
      background-color: #ededed !important;
    }
  </style>
</html>










        `;
                const WinPrint = window.open();
                let is_chrome = Boolean(WinPrint.chrome);
                WinPrint.document.write(reportHTML);
                if (is_chrome) {
                    setTimeout(function () {
                        WinPrint.document.close();
                        WinPrint.focus();
                        WinPrint.print();
                    }, 1000);
                } else {
                    WinPrint.document.close();
                    WinPrint.focus();
                }
            } catch (error) {
                console.log(error);
                this.Stop();
                this.projects = [];
                this.totalProjects = 0;
                this.$notify({
                    title: "خطأ",
                    message: "يوجد خطاء في الطباعة",
                    position: "bottom-right",
                    type: "error",
                });
                //return this.notifyVue("top", "center", "danger", error);
            }
        },

















        Back() {
            this.state = 0;
            this.TodayPatient = [];
            this.Refresh();
        },

        Refresh() {
            this.CityId = '';
            this.Municipalities = '';
            this.MunicipalitiesId = '';
            this.KidnyCenter = '';
            this.KidneyCenterId = '';
            this.PatientId = '';
            this.Patient = [];
            this.Devices = [];
            this.DeviceId = '';
            this.CompanyId = '';
            this.Felters = [];
            this.FilterId = '';
            this.ByDate = '';

            this.GetInfo();
            
        },

        ChangeDate(date) {
                if (date === null) {
                    return "فارغ";
                }
                return moment(date).format("YYYY-MM-DD");
        },
    },
};
